//da anagarafare in audience lead
import React, { useState, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Detail as DetailComponent, InfoHeader, useDrawer } from '../../../../mtska-frontend-app-component';
import { useDataProvider } from '../../../../mtska-frontend-data-provider';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';
import { CircularProgress } from '@mui/joy';
import { Backdrop } from "@mui/material"

const dataProviderName = 'campaigns/campaignactivity';
const wizardName = 'CampaignActivityCreate';
const wizardAction = 'create';
const wizardObject = 'CampaignActivity';

const CampaignActivityCreate = (params) => {
    const { t } = useTranslation();
    const { close } = useDrawer();
    const { userCapabilities, existingModules } = useContext(AppContext);
    const [drawable, setDrawable] = useState(true);
    const [localError, setLocalError] = useState();

    // DATA PROVIDER
    const {
        errorMessage,
        errors,
        saving,
        success,
        loadOne
    } = useDataProvider(dataProviderName, false);

    const modelName = existingModules.modelName;

    let detailConfig = {
        "steps": [
            {
                "name": "Selezione portfolio",
                "tabs": [
                    {
                        "name": "portfolio_select",
                        "fieldsets": [
                            {
                                "name": "portfolio_select",
                                "fields": {
                                    "portfolioId": {
                                        "type": "select",
                                        "className": "col-12",
                                        "label": t("Seleziona un Portfolio da importare"),
                                        "options": [],
                                        "dataProvider": "audiences/audiencemargo/portfolio"
                                    },
                                }
                            }
                        ]
                    }
                ],
            },
            {
                "name": "Importazione",
                "tabs": [
                    {
                        "name": "import_launch",
                        "fieldsets": [
                            {
                                "name": "import_launch",
                                "fields": {
                                    "import_launch": {
                                        "type": "sectionmessageblock",
                                        "title": t("Importazione da Margò"),
                                        "paragraph": t("L'importazione può durare qualche minuto, in base al numero di lead contenute del Portfolio."),
                                        "icon": "faClock",
                                        "className": "col-12 warning"
                                    },
                                }
                            }
                        ]
                    }
                ],
            }
        ],
        "validation": []
    }

    const onProcessStepAction = (currentStep, stepTotal, actionInvoked, getValues) => {
        //console.info('onProcessStepAction currentStep:', currentStep, 'stepTotal:', stepTotal, 'actionInvoked:', actionInvoked, getValues());
        setLocalError();
        const values = getValues();

        if (actionInvoked > 0 && currentStep == 0 && values['portfolioId'] == undefined) {
            setLocalError("Seleziona un portfolio da importare");
        } else if (actionInvoked > 0 && (currentStep + 1) == stepTotal) {
            const portfolioId = values['portfolioId'];

            loadOne(portfolioId).then(() => {
                params.handleClose(params.uid)
            }).catch((e) => console.error('catch loadOne', e));

        } else {
            return true;
        }
    }


    return (
        !drawable ? <Backdrop open={!drawable} style={{ backgroundColor: "white" }}><CircularProgress /></Backdrop> :
            <DetailComponent
                disableDetailConfigOverride={true}
                values={{
                    "confirm": "true",
                    "ids": params?.filters?.items
                }}
                modelName={modelName}
                detailConfig={detailConfig}
                dataProviderName={dataProviderName}
                saving={saving}
                errors={errors}
                errorMessage={errorMessage}
                alertMessage={localError}
                title={t(wizardName)}
                canSave={userCapabilities && userCapabilities[dataProviderName + '.' + wizardAction.toLowerCase()]}
                header={
                    <InfoHeader
                        view="wizard"
                        title={t(wizardName)}
                        subtitle={t('Lancia importazione da Margò')}
                    />
                }
                onProcessStepAction={onProcessStepAction}
                //onValidateStepAction={onValidateStepAction}
                {...params}
            />
    )
}

export default CampaignActivityCreate;